// PythonEditor.jsx
import React, { useState } from "react";
import Editor from "@monaco-editor/react";

const PythonEditor = ({ code }) => {
  // const [code, setCode] = useState(`# Write Python code here\nprint("Hello, Python!")`);

  const handleRun = () => {
    console.log("Python code:", code);
  };

  return (
    <div style={{ height: "60vh", display: "flex", flexDirection: "column" }}>
      <Editor
        height="60vh"
        defaultLanguage="python"
        // theme="vs-dark"
        value={code}
        // onChange={(value) => setCode(value)}
      
        options={{
        
          fontSize: 14,
          minimap: { enabled: false },
          lineNumbers: "on",
             readOnly: true,         // 👈 disables editing
        domReadOnly: true, 
        }}
      />
      {/* <button
        onClick={handleRun}
        style={{
          marginTop: "10px",
          padding: "10px 20px",
          background: "#1e90ff",
          border: "none",
          color: "#fff",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Run Code
      </button> */}
    </div>
  );
};

export default PythonEditor;
